export default {
  buttons: {
    apply: "Aplicar",
    cancel: "CANCELAR",
    dismiss: "Cerrar",
    minimize: "minimizar",
    unminimize: "Desminiminzar",
    add_waypoint: "Añadir un destino"
  },
  distance: {
    value: "{distance, number, distance} {unit}"
  },
  send_to_phone: {
    mail: {
      body: "{url}"
    }
  },
  search: {
    title: "Buscar",
    placeholder: "Ingrese ubicación",
    enter_location: "Ingrese ubicación",
    recent_searches: "Búsquedas recientes",
    suggestions: "Sugerencias",
    geolocation: "Utilizar mi ubicación",
    help: {
      inactive: "Buscar",
      clear: "Borrar"
    }
  },
  filters: {
    title: "Filtros",
    more: "Más filtros",
    less: "Menos filtros",
    group: {
      more: "Más",
      less: "Menos"
    },
    amenities: {
      title: "Servicios y amenidades"
    },
    fuels: {
      title: "Tipos de combustibles"
    }
  },
  directions: {
    title: "Sistema de planeación de ruta",
    help: {
      add_waypoint: "Añadir lugar",
      reverse: "Invertir direcciones",
      sort_waypoint: "Arrastre para reordenar",
      remove: "Remover punto de ruta"
    },
    placeholder: {
      origin: "Escoger punto de inicio",
      destination: "Ingrese ubicación",
      waypoint: "Ingrese ubicación"
    },
    route: {
      title: "Opciones de ruta",
      title_avoid: "Evitar",
      avoid_tolls: "Evitar carreteras de cuota",
      avoid_highways: "Evitar autopistas",
      avoid_ferries: "Evitar transbordadores de vehículos (Ferris)",
      title_corridor: "Distancia de la ruta a las estaciones de servicio"
    },
    travel_time: `\
{weeks, plural, =0 {} =1 {# semana} other {# semanas}}
{days, plural, =0 {} =1 {# día} other {# días}}
{hours, plural, =0 {} =1 {# hr} other {# hrs}}
{minutes, plural, =0 {} =1 {# min} other {# mins}}\
`,
    button: "Buscar",
    error: "Hubo un problema al procesar tu ruta. Por favor intenta de nuevo."
  },
  action_panel: {
    back_to_results: "Volver a resultados"
  },
  locations: {
    title: "Ubicaciones",
    closed_temporarily: "Cerrado temporalmente",
    distance: "{distance, number, distance} {unit}",
    distance_from: "{distance, number, distance} {unit} de {place}",
    description: "{visible, select, true {Ocultar} false {Mostrar} }"
  },
  open_now: {
    open_24_hours: "Abierto las 24 horas"
  },
  info_window: {
    back_to_results: "Volver a resultados",
    title: "Detalles de la estación",
    location_id: "Identificación de la estación",
    website: "Página Web",
    services: "Servicios y amenidades",
    nearby: "Cerca",
    directions: "Añadir a planeación de rutas",
    opening_hours: {
      title: "Horarios de cierre y apertura",
      mon: "Lu",
      tue: "Ma",
      wed: "Mi",
      thu: "Ju",
      fri: "Vi",
      sat: "Sa",
      sun: "Do",
      open_twentyfourhours: "Abierto las 24 horas",
      period: "{start, time, short} – {end, time, short}"
    },
    fuel_prices: {
      available: "Combustibles y precios Disponibles",
      not_available: "Combustible disponible",
      price: "{price, number, fuelPrice}",
      disclaimer:
        "Toda la información es proporcionada sin garantía alguna, únicamente tienen validez los precios en los dispensadores.",
      last_updated_on: "Última actualización",
      timestamp: "{timestamp, date, dateFormat}"
    }
  },
  itinerary: {
    title: "Sistema de planeación de ruta"
  },
  fuels: {
    premium_diesel: "Diesel Premium",
    premium_gasoline: "Gasolina Premium",
    shell_regular_diesel: "Diesel Shell Regular"
  },
  amenities: {
    air_and_water: "Aire y agua",
    atm_in: "Cajero Automático-en el interior",
    atm_out: "Cajero Automático-en el exterior",
    atm: "Cajero Automático",
    austrian_highway_sticker: "Calcomanía de autopista austriaca",
    bakery_shop: "Pandería",
    bottled_gas: "Cambio de cilindros de gas propano",
    cafe: "Cafetería",
    carwash: "Autolavado",
    childs_toilet: "Baño - para niños",
    credit_card_american_express: "Tarjeta de Crédito - American Express",
    credit_card_diners_club: "Tarjeta de Crédito - Diners Club",
    credit_card_general: "Tarjeta de Crédito - General",
    credit_card_mastercard: "Tarjeta de Crédito - MasterCard",
    credit_card_visa: "Tarjeta de Crédito - Visa",
    credit_card: "Tarjeta de Crédito",
    czech_highway_sticker: "Calcomanía de autopista checa",
    disability_assistance: "Asitencia para discapacitados",
    disabled_facilities: "Facilidad de acceso para Discapacitados",
    euroshell_card: "euroShell/Tarjeta Shell",
    fleet_card_dkv: "Tarjeta de visita",
    fleet_card_eni: "Tarjeta de flotilla - Eni",
    fleet_card_esso: "Tarjeta de flotilla - Esso",
    fleet_card_general: "Tarjeta de flotilla",
    fleet_card_uta: "Tarjeta de flotilla - UTA",
    food_offerings: "Opciones de alimentos",
    fuel_card: "Tarjeta de Combustibles",
    full_service: "servicio completo",
    guarded_car_park: "Estacionamiento",
    hgv_lane: "Conveniente para camiones",
    high_speed_diesel_pump: "Diesel de alta velocidad",
    hot_food: "Comida caliente",
    hungarian_highway_sticker: "Calcomanía de autopista húngara",
    jet: "Chorro de agua apPresión",
    loyalty_cards: "Tarjetas de Lealtad",
    maut_terminal: "Tarjeta inteligente de cuota",
    mobile_payment: "Pagos móviles",
    motorway_service: "Servicios en las autopistas",
    oil_and_lubricants: "Aceites y lubricantes",
    parking_lanes: "Carril de estacionamiento",
    partner_loyalty_accepted: "Se aceptan programas de lealtad",
    pay_at_pump: "Pagar en el dispensador",
    restaurant: "Restaurante",
    selectshop: "tienda Shell Select",
    self_service: "Auto servicio",
    service_bay: "Bahías de servicio",
    shell_card: "euroShell/Tarjeta Shell",
    shell_club_smart_extra_card: "Tarjeta extra para Shell ClubSmart",
    shop: "Tienda",
    shower: "Regaderas",
    slovak_highway_sticker: "Calcomanía de autopista eslovaca",
    snack_food: "Snacks/Comida Rápida",
    standard_toilet: "Baño",
    supermarket_fuel_discount: "Descuento en combustibles",
    toilet: "Baño",
    truck_parking: "Estacionamiento de camiones",
    truckport: "Únicamente camiones",
    twenty_four_hour: "24 horas",
    twotheloo: "Al baño",
    unmanned: "No atendida",
    vacuum: "Aspiradora",
    vehicle_identity_system: "Sistema de identificación de vehículo"
  },
  settings: {
    title: "Ajustes",
    tooltip: "Ajustes",
    traffic: "Tráfico",
    distance_units: {
      title: "Distancia",
      km: "Kilometros",
      miles: "Millas"
    },
    language: {
      title: "Idioma",
      locales: {
        es_AR: "Español de Argentina",
        en_AU: "Inglés de Australia",
        fr_BE: "Francés de Bélgica",
        nl_BE: "Holandés de Bélgica",
        pt_BR: "Portugués de Brasil",
        en_BG: "Inglés de Bulgaria",
        bg_BG: "Búlgaro de Bulgaria",
        fr_CA: "Francés de Canadá",
        en_CA: "Inglés de Canadá",
        cz_CZ: "Checo de la Rep. Checa",
        da_DK: "Danés de Dinamarca",
        fi_FI: "Finlandés de Finlandia",
        fr_FR: "Francés de Francia",
        de_DE: "Alemán de Alemania",
        en_HK: "Inglés de Hong Kong",
        zh_HK: "Chino de Hong Kong",
        hu_HU: "Húngaro de Hungría",
        en_IN: "Inglés de India",
        en_ID: "Inglés de Indonesia",
        id_ID: "Indonesio de Indonesia",
        it_IT: "Italiano de Italia",
        lv_LV: "Letón de Latvia",
        lt_LT: "Lituano de Lituania",
        fr_LU: "Francés de Luxemburgo",
        en_LU: "Inglés de Luxemburgo",
        en_MY: "Inglés de Malasia",
        en_MO: "Inglés de Macao",
        zh_MO: "Chino de Macao",
        nl_NL: "Holandés de los Países Bajos",
        nb_NO: "Noruego de Noruega (Bokmal)",
        en_OM: "Inglés de Omán",
        ar_OM: "Árabe de Omán",
        en_PK: "Inglés de Pakistán",
        ur_PK: "Urdu de Pakistán",
        en_PH: "Inglés de Filipinas",
        pl_PL: "Polaco de Polonia",
        es_PR: "Español de Puerto Rico",
        ro_RO: "Rumano de Rumania",
        ru_RU: "Ruso de Rusia",
        en_SG: "Inglés de Singapúr",
        sk_SK: "Eslovaco de Eslovaquia",
        sl_SI: "Esloveno de Eslovenia",
        en_ZA: "Inglés de Sudáfrica",
        sv_SE: "Sueco de Suecia",
        fr_CH: "Francés de Suiza",
        de_CH: "Alemán de Suiza",
        th_TH: "Tailandés de Tailandia",
        tr_TR: "Turco de Turquía",
        uk_UA: "Ucraniano de Ucrania",
        en_GB: "Inglés del Reino Unido",
        en_US: "Inglés de los EEUU"
      }
    }
  },
  geolocation: {
    tooltip: "Utilizar mi ubicación"
  }
}
